export default __webpack_public_path__ + "static/media/foto3.2ea879e0.jpg";